// 本人確認情報編集画面の戻り先
export enum IdentityEditReturnTo {
  Clients = 'clients',
  Identities = 'identities',
}

export enum VerificationMethod {
  manual = "manual",
  ekyc = "ekyc",
}

export function getVerificationMethodLabel(method: VerificationMethod): string {
  switch (method) {
    case VerificationMethod.manual:
      return "手動";
    case VerificationMethod.ekyc:
      return "eKYC";
    default:
      return method;
  }
}

export enum VerificationStatus {
  not_submitted = "not_submitted",
  verified = "verified",
  deficiency = "deficiency",
}

export function getVerificationStatusLabel(status: VerificationStatus): string {
  switch (status) {
    case VerificationStatus.not_submitted:
      return "未提出";
    case VerificationStatus.verified:
      return "確認済";
    case VerificationStatus.deficiency:
      return "不備";
    default:
      return status;
  }
}

export function getVerificationStatusVariant(
  status: VerificationStatus
): "default" | "secondary" | "destructive" | "outline" {
  switch (status) {
    case VerificationStatus.not_submitted:
      return "outline";
    case VerificationStatus.verified:
      return "default";
    case VerificationStatus.deficiency:
      return "destructive";
    default:
      return "outline";
  }
}

